import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { NavMenuPrimitives } from '@uhg-abyss/web/ui/NavMenu';
import { StateRouter } from '@uhg-abyss/web/ui/StateRouter';
import React from 'react';
import { checkInternalRole } from '@src/common/Utils/utils';

const getDropdownMenuContent = (
  menu,
  menuTitle,
  eventTitle,
  type,
  fireHeaderEvent,
  routeToPage
) => {
  return (
    <React.Fragment>
      <NavMenuPrimitives.Trigger>{menuTitle}</NavMenuPrimitives.Trigger>
      <NavMenuPrimitives.Content>
        <NavMenuPrimitives.Columns>
          <NavMenuPrimitives.Column title={menuTitle}>
            {menu &&
              menu.leftSubMenu &&
              menu.leftSubMenu.map((item) => {
                return (
                  <NavMenuPrimitives.MenuItem
                    title={item.title}
                    onClick={() => {
                      fireHeaderEvent(item.title, eventTitle);
                      routeToPage({
                        url: item.link,
                      });
                    }}
                  />
                );
              })}
          </NavMenuPrimitives.Column>
          <NavMenuPrimitives.Column>
            {menu &&
              menu?.rightSubMenu &&
              menu?.rightSubMenu.map((item) => {
                return (
                  <NavMenuPrimitives.MenuItem
                    title={item.title}
                    onClick={() => {
                      fireHeaderEvent(item.title, eventTitle);
                      routeToPage({
                        url: item.link,
                      });
                    }}
                  />
                );
              })}
          </NavMenuPrimitives.Column>
        </NavMenuPrimitives.Columns>
      </NavMenuPrimitives.Content>
    </React.Fragment>
  );
};

const getResourcesContent = (
  fireHeaderEvent,
  routeToPage,
  dsUserInfo,
  device
) => {
  const hasInternalRole = checkInternalRole(dsUserInfo);
  return device ? (
    <StateRouter.Route path="/home/Resources" title="Resources">
      <Heading
        css={{ padding: '0px $md' }}
        offset={4}
        fontWeight="$bold"
        id="utility-items-title"
      >
        Resources
      </Heading>
      <Layout.Stack
        grow
        as="ul"
        aria-labelledby="utility-items-title"
        css={{
          '&[li]': {
            listStyle: 'none',
            margin: 0,
            padding: 0,
          },
        }}
      >
        <li>
          <NavMenuPrimitives.MenuItem
            title="Overview"
            onClick={() => {
              fireHeaderEvent('Overview', 'Resources');
              routeToPage({
                url: '/getting-started',
              });
            }}
          />
        </li>
        {dsUserInfo?.status &&
          dsUserInfo?.status === 'ACTIVE' &&
          !hasInternalRole && (
            <li>
              <NavMenuPrimitives.MenuItem
                title="Credentials"
                onClick={() => {
                  fireHeaderEvent('Credentials', 'Resources');
                  routeToPage({
                    url: '/welcome/credentials',
                  });
                }}
              />
            </li>
          )}
        <Heading
          css={{ padding: '0px $md' }}
          offset={4}
          fontWeight="$bold"
          id="utility-items-title"
        >
          Additional Resources{' '}
        </Heading>
        <li>
          <NavMenuPrimitives.MenuItem
            title="Release Notes"
            onClick={() => {
              fireHeaderEvent('Release Notes', 'Resources');
              routeToPage({
                url: '/welcome/release-notes/apim-latest-notes',
              });
            }}
          />
        </li>
      </Layout.Stack>
    </StateRouter.Route>
  ) : (
    <React.Fragment>
      <NavMenuPrimitives.Trigger css={{ fontSize: '15px', fontWeight: 600 }}>
        Resources
      </NavMenuPrimitives.Trigger>
      <NavMenuPrimitives.Content>
        <NavMenuPrimitives.Columns>
          <NavMenuPrimitives.Column title="Getting Started">
            <NavMenuPrimitives.MenuItem
              title="Overview"
              onClick={() => {
                fireHeaderEvent('Overview', 'Resources');
                routeToPage({
                  url: '/getting-started',
                });
              }}
            />
            {dsUserInfo?.status &&
              dsUserInfo?.status === 'ACTIVE' &&
              !hasInternalRole && (
                <NavMenuPrimitives.MenuItem
                  title="Credentials"
                  onClick={() => {
                    fireHeaderEvent('Credentials', 'Resources');
                    routeToPage({
                      url: '/welcome/credentials',
                    });
                  }}
                />
              )}
          </NavMenuPrimitives.Column>
          <NavMenuPrimitives.Column title="Additional Resources">
            <NavMenuPrimitives.MenuItem
              title="Release Notes"
              onClick={() => {
                fireHeaderEvent('Release Notes', 'Resources');
                routeToPage({
                  url: '/welcome/release-notes/apim-latest-notes',
                });
              }}
            />
          </NavMenuPrimitives.Column>
        </NavMenuPrimitives.Columns>
      </NavMenuPrimitives.Content>
    </React.Fragment>
  );
};

const getCommunicationsCornerContent = (
  fireHeaderEvent,
  routeToPage,
  setShowSubscribeAPIModal,
  dsUserInfo,
  device
) => {
  return device ? (
    <StateRouter.Route
      path="/home/Communications Corner"
      title="Communications Corner"
    >
      <Heading
        css={{ padding: '0px $md' }}
        offset={4}
        fontWeight="$bold"
        id="utility-items-title"
      >
        Communications Corner
      </Heading>
      <Layout.Stack
        grow
        as="ul"
        aria-labelledby="utility-items-title"
        css={{
          '&[li]': {
            listStyle: 'none',
            margin: 0,
            padding: 0,
          },
        }}
      >
        <li>
          <NavMenuPrimitives.MenuItem
            title="Connect with a Consultant"
            onClick={() => {
              fireHeaderEvent(
                'Connect with a Consultant',
                'Communications Corner'
              );
              const isConnected =
                dsUserInfo.status === 'ACTIVE' ||
                dsUserInfo.status === 'PENDING' ||
                dsUserInfo.status === 'DENIED';
              if (!isConnected) {
                routeToPage({
                  url: '/welcome/intake',
                });
              } else {
                setShowSubscribeAPIModal(true);
              }
            }}
          />
        </li>
        {dsUserInfo?.status && dsUserInfo?.status === 'ACTIVE' && (
          <li>
            <NavMenuPrimitives.MenuItem
              title="All Communications"
              onClick={() => {
                fireHeaderEvent('All Communications', 'Communications Corner');
                routeToPage({
                  url: '/welcome/all-communications',
                });
              }}
            />
          </li>
        )}
      </Layout.Stack>
    </StateRouter.Route>
  ) : (
    <React.Fragment>
      <NavMenuPrimitives.Trigger css={{ fontSize: '15px', fontWeight: 600 }}>
        Communications Corner
      </NavMenuPrimitives.Trigger>
      <NavMenuPrimitives.Content>
        <NavMenuPrimitives.Columns>
          <NavMenuPrimitives.Column title="Communications Corner">
            <NavMenuPrimitives.MenuItem
              title="Connect with a Consultant"
              onClick={() => {
                fireHeaderEvent(
                  'Connect with a Consultant',
                  'Communications Corner'
                );
                const isConnected =
                  dsUserInfo.status === 'ACTIVE' ||
                  dsUserInfo.status === 'PENDING' ||
                  dsUserInfo.status === 'DENIED';
                if (!isConnected) {
                  routeToPage({
                    url: '/welcome/intake',
                  });
                } else {
                  setShowSubscribeAPIModal(true);
                }
              }}
            />
          </NavMenuPrimitives.Column>
          {dsUserInfo?.status && dsUserInfo?.status === 'ACTIVE' && (
            <NavMenuPrimitives.Column
              title=" "
              css={{
                'abyss-nav-menu-column-root': { borderLeft: 'none !important' },
              }}
            >
              <NavMenuPrimitives.MenuItem
                title="All Communications"
                onClick={() => {
                  fireHeaderEvent(
                    'All Communications',
                    'Communications Corner'
                  );
                  routeToPage({
                    url: '/welcome/all-communications',
                  });
                }}
              />
            </NavMenuPrimitives.Column>
          )}
        </NavMenuPrimitives.Columns>
      </NavMenuPrimitives.Content>
    </React.Fragment>
  );
};

export {
  getDropdownMenuContent,
  getResourcesContent,
  getCommunicationsCornerContent,
};
